import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, ButtonGroup, Col, Row, Table } from "reactstrap";
import { SortHeader } from ".";

export default function TopCustomersBySalesGrid(props) {
  const [data, setData] = useState();
  const [working, setWorking] = useState(false);

  useEffect(() => {
    if (data !== props.data) {
      setData(props.data);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data]);

  function getExcel() {
    setWorking(true);
    props.exportXlsxCallback();
    setWorking(false);
  }

  return data && data.items ? (
    <>
      <Row className="align-items-center">
        <Col className="transparent-background"></Col>
        <Col className="transparent-background">
          <ButtonGroup className="float-end">
            {data &&
              data.items &&
              data.items.length &&
              props.exportXlsxCallback && (
                <Button
                  title="Download as .xlsx"
                  className="shredButtonExcel float-end ms-2"
                  onClick={getExcel}
                  disabled={working}
                >
                  <FontAwesomeIcon icon="file-excel" size="lg" />
                </Button>
              )}
          </ButtonGroup>
        </Col>
      </Row>
      <Table size="sm" className="data-table">
        <thead className="table-header">
          <tr>
            <th style={{ width: "23%" }}>
              <SortHeader
                displayName={<span>Customer</span>}
                field="customerId"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "customerId"}
                callback={props.sortCallback}
              />
            </th>
             <th style={{ width: "8%" }}>
              <SortHeader
                displayName={
                  <span>
                    Current <br /> Sales
                  </span>
                }
                field="CurrentSales"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "CurrentSales"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "10%" }}>
              <SortHeader
                displayName={
                  <span>
                    Previous <br /> Sales
                  </span>
                }
                field="PreviousSales"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "PreviousSales"}
                callback={props.sortCallback}
              />
            </th>
            {/* not sorting */}
            <th style={{ width: "7%" }}>
              <SortHeader
                displayName={
                  <span>
                    Sales <br /> +/-
                  </span>
                }
                field="SalesIncrease"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "SalesIncrease"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "10%" }}>
              <SortHeader
                displayName={
                  <span>
                    Curent <br /> Sales <br /> (lbs)
                  </span>
                }
                field="CurrentSalesQty"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "CurrentSalesQty"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "10%" }}>
              <SortHeader
                displayName={
                  <span>
                    Previous <br /> Sales <br /> (lbs)
                  </span>
                }
                field="PreviousSalesQty"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "PreviousSalesQty"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "7%" }}>
              <SortHeader
                displayName={
                  <span>
                    Sales <br /> (lbs) <br /> +/-
                  </span>
                }
                field="SalesQtyIncrease"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "SalesQtyIncrease"}
                callback={props.sortCallback}
              />
            </th>
            {/* not sorting */}
            <th style={{ width: "7%" }}>
              <SortHeader
                displayName={
                  <span>
                    Current <br /> Margin
                  </span>
                }
                field="CurrentMargin"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "CurrentMargin"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "7%" }}>
              <SortHeader
                displayName={
                  <span>
                    Previous <br /> Margin
                  </span>
                }
                field="PreviousMargin"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "PreviousMargin"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "7%" }}>
              <SortHeader
                displayName={
                  <span>
                    Margin <br /> +/-
                  </span>
                }
                field="MarginChange"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "MarginChange"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "10%" }}>
              <SortHeader
                displayName={
                  <span>
                    Sales <br /> Person
                  </span>
                }
                field="SalespersonId"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "SalespersonId"}
                callback={props.sortCallback}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {_.map(data.items, (datum, index) => {
            return (
              <tr
                key={index}
                className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
              >
                <td className="data-cell">
                  <Link
                    style={{ textDecoration: "none" }}
                    className="shredLink fw-bold"
                    to={`/customer-dashboard/${datum.customerId}`}
                  >
                    {datum.customerIdName}
                  </Link>
                </td>
                <td
                  className="data-cell"
                  children={datum.currentSalesDisplay}
                />
                <td
                  className="data-cell"
                  children={datum.previousSalesDisplay}
                />
                <td
                  className="data-cell"
                  children={datum.salesIncreaseDisplay}
                  style={datum.salesIncrease <= 0 ? { color: "red" } : null}
                />
                <td
                  className="data-cell"
                  children={datum.currentSalesQtyDisplay}
                />
                <td
                  className="data-cell"
                  children={datum.previousSalesQtyDisplay}
                />
                <td
                  className="data-cell"
                  children={datum.salesQtyIncreaseDisplay}
                  style={datum.salesQtyIncrease <= 0 ? { color: "red" } : null}
                />
                <td
                  className="data-cell"
                  children={datum.currentMarginDisplay}
                  style={datum.currentMargin <= 0 ? { color: "red" } : null}
                />
                <td
                  className="data-cell"
                  children={datum.previousMarginDisplay}
                  style={datum.previousMargin < 0 ? { color: "red" } : null}
                />
                <td
                  className="data-cell"
                  children={datum.marginChangeDisplay}
                  style={datum.marginChange <= 0 ? { color: "red" } : null}
                />
                <td className="data-cell" children={datum.salespersonId} />
              </tr>
            );
          })}
        </tbody>
        <tfoot className="table-footer">
          <tr>
            <td
              className={`fw-bold`}
              // colSpan={!currentUser?.isAnyCustomerTypeRole ? "7" : "6"}
              children=""
            />
            <td className={`fw-bold`}>{data.ytdSalesDisplay}</td>
            <td className={`fw-bold`}>{data.previousYTDSalesDisplay}</td>
            <td className={`fw-bold`}>{data.percentChangeSalesDisplay}</td>
            <td className={`fw-bold`}>{data.ytdLbsDisplay}</td>
            <td className={`fw-bold`}>{data.previousYTDLbsDisplay}</td>
            <td className={`fw-bold`}>{data.percentChangeLbsDisplay}</td>
            <td className={`fw-bold`}>{data.currentMarginTotalDisplay}</td>
            <td className={`fw-bold`}>{data.previousMarginTotalDisplay}</td>
            <td className={`fw-bold`}>{data.marginChangeTotalDisplay}</td>
            <td></td>
          </tr>
        </tfoot>
      </Table>
    </>
  ) : null;
}
